import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
    MxButtonModel, MxDynamicFormService, MxFormCustomizerEvent,
    MxNotificationService, OnBoFormReady, UiDataObj, MxPreloaderService, withPreloader
} from 'mx-core';
import {MatDialogRef} from '@angular/material/dialog';
import {HttpClient} from "@angular/common/http";
import {combineLatestAll, of, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {PrlTranslateService} from "../../../../../shared/services/prl-translate.service";
import {PortalMessageService} from "../../../services/portal-message.service";

@Component({
    templateUrl: './prl-new-message.component.html',
    standalone: false,
    styleUrls: ['./prl-new-message.component.scss']
})
export class PrlNewMessageComponent implements OnInit, OnDestroy, OnBoFormReady {
    private _destroy$$: Subject<null> = new Subject<null>();

    form: FormGroup = new FormGroup({
        subject: new FormControl('', Validators.required),
        body: new FormControl('', [Validators.required]),
    });

    submitButton: MxButtonModel;
    cancelButton: MxButtonModel;

    @Input() error: string | null;

    constructor(
        private httpClient: HttpClient,
        private notificationService: MxNotificationService,
        private dialogRef: MatDialogRef<PrlNewMessageComponent>,
        private dynamicFormService: MxDynamicFormService,
        private preloader: MxPreloaderService,
        protected translateService: PrlTranslateService,
        private dataService: PortalMessageService,
    ) {
    }

    ngOnInit(): void {
        this.cancelButton = {
            label: () => this.translateService.getTranslatedLabel('label.cancel'),
            tooltip: () => this.translateService.getTranslatedLabel('label.cancel'),
            className: 'mxs-button--secondary',
            clickHandler: this.close
        };
        this.submitButton = {
            label: () => this.translateService.getTranslatedLabel('label.send'),
            permission: 'all',
            tooltip: () => this.translateService.getTranslatedLabel('label.send'),
            className: 'mxs-button--primary',
            clickHandler: this.submit,
            disabled: () => this.form.invalid,
        };
        this.checkWarning();
    }

    submit = () => {
        const message = {
            subject: this.form.get('subject')?.value,
            body: this.form.get('body')?.value
        };
        this.dataService.sendMessage(message).subscribe({
            next: () => this.dialogRef.close()
        });
    };


    close = () => {
        this.dialogRef.close();
    };

    private checkWarning(): void {
        let warning = localStorage.getItem('Warning');
        if (warning) {
            this.notificationService.showFailure(warning);
            localStorage.removeItem('Warning');
        }
    }


    boOnFormReady(form: FormGroup): void {
        this.form = form;
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }


    onCustomize(event: MxFormCustomizerEvent): void {
        event.fieldsData.next({
            objectMetaSource: null,
            initialData: {}
        });
        event
            .customizeBoFormConfig({title: 'label.dashboard.message.create'})
            .customizeActions({
                submit: {text: 'label.submit', visible: false},
                cancel: {text: 'label.cancel', visible: false}
            })
            .customizeFieldConfigs('message', {style: 'half-width-column'})
            .customizeFieldConfigs('title', {style: 'half-width-column'})

        of(
            this.dynamicFormService.getUIData('com.playtech.mexos.portalnew.contract.MessagePrlObj')
        ).pipe(takeUntil(this._destroy$$), withPreloader(this.preloader), combineLatestAll())
            .subscribe((response) => {
                let fieldSource: UiDataObj = response[0] as UiDataObj;
                event.fieldsData.next({
                    objectMetaSource: fieldSource,
                    initialData: {}
                });
            });
        event.addCustomizer(this);
    }
}
